import { Path } from '@/main/router/routerPath';

import { SegmentCategory } from './segmentcategory';
import { SegmentSubCategory } from './segmentsubcategory';

export const router = new Path('CorporateSegment').addChildren([
	SegmentCategory.router,
	SegmentSubCategory.router,
]);
